import produce from 'immer';
import { ActionTypes } from './offer.actions';

export const initialState = {
    offers: {},
    files: {}
};




const reducer = (state = initialState, action) => produce(state, (draft) => {
    switch (action.type) {
        case ActionTypes.fetchJobOfferLinkCompleted: {
            const { applicationId, offer } = action.payload;
            draft.offers[applicationId] = offer;
            return draft;
        }
        case ActionTypes.fetchJobOfferLinkFileCompleted: {
            const { applicationId, file } = action.payload;
            draft.files[applicationId] = file;
            return draft;
        }
        case ActionTypes.deleteJobOfferLink:
        case ActionTypes.deleteJobOfferLinkCompleted: {
            const { applicationId } = action.payload;
            draft.offers[applicationId] = null;
            draft.files[applicationId] = null;
            return draft;
        }
        default: {
            return state;
        }
    }
});
export default reducer;

